<div class="page-header">
  <a [routerLink]="isInternal ? '/internal' : '/invitations'"
    ><img src="../../assets/img/logo.png" alt="logo"
  /></a>

  <!-- PA: address search bar -->
  <div class="page-header__search" *ngIf="!isInternal">
    <input
      id="globalSearch"
      type="text"
      class="page-header__search"
      placeholder="Search for an address"
      [(ngModel)]="searchTerm"
      (keyup.enter)="search()"
    />
    <button class="page-header__search__button" (click)="search()">
      <span class="material-icons">search</span>
    </button>
  </div>

  <!-- Internal: top-level nav links -->
  <div class="page-header__nav" *ngIf="isInternal">
    <a routerLink="/internal/dashboard" class="page-header__nav__link">
      <span class="material-icons">admin_panel_settings</span>
      Internal
    </a>
  </div>

  <div class="page-header__buttons">
    <!-- future implementation -->
    <!-- <button class="page-header__buttons__button" (click)="calendar()">
			<div class="page-header__buttons__button__icon"><span class="material-icons">calendar_month</span>
			</div>Calendar
		</button> -->

    <!-- PA only: notifications -->
    <button
      *ngIf="!isInternal"
      class="page-header__buttons__button"
      (click)="toggleNotificationsModal()"
    >
      <div
        class="page-header__buttons__button__icon"
        [matBadge]="unreadNotifications?.length"
        [matBadgeHidden]="unreadNotifications?.length < 1"
        matBadgeColor="primary"
      >
        <span class="material-icons">notifications</span>
      </div>
      Notifications
    </button>

    <!-- shared inner content for the My Account button -->
    <ng-template #accountBtnContent>
      <div
        class="page-header__buttons__button"
        *ngIf="userProfilePic; else noPhoto"
      >
        <img [src]="userProfilePic" alt="Profile Picture" />
      </div>
      <ng-template #noPhoto>
        <div class="page-header__buttons__button__icon">
          <span class="material-icons">account_circle</span>
        </div>
      </ng-template>
      My Account
    </ng-template>

    <!-- PA: navigate to profile page -->
    <button
      *ngIf="!isInternal"
      class="page-header__buttons__button"
      routerLink="manageaccount"
    >
      <ng-container *ngTemplateOutlet="accountBtnContent"></ng-container>
    </button>

    <!-- Internal: open dropdown menu -->
    <button
      *ngIf="isInternal"
      class="page-header__buttons__button"
      [matMenuTriggerFor]="accountMenu"
    >
      <ng-container *ngTemplateOutlet="accountBtnContent"></ng-container>
    </button>
    <mat-menu #accountMenu="matMenu">
      <button mat-menu-item disabled>Alias User (coming soon)</button>
      <button mat-menu-item (click)="logout()">Log Out</button>
    </mat-menu>
  </div>

  <notification-dialog
    *ngIf="!isInternal"
    [active]="notificationsActive"
    (modalClosed)="toggleNotificationsModal()"
    (markAllAsRead)="markAllAsRead()"
    (markAsRead)="markAsRead($event)"
    (markAsUnread)="markAsUnread($event)"
    [readNotifications]="readNotifications"
    [unreadNotifications]="unreadNotifications"
  ></notification-dialog>
</div>
